import {
  Zap,
  Activity,
  TrendingUp,
  Bolt,
  RotateCcw,
  Eye,
  BatteryCharging,
  ChevronDown,
  ChevronLeft,
  Gauge,
  Divide,
  Scale,
  Radar,
  Bell,
  SignalHigh,
  Settings,
  Layers3,
  X
} from "lucide-react";
import { NavLink, useParams, useLocation } from "react-router-dom";
import { useState } from "react";
import { Home } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Sidebar({ isOpen, onClose }) {
  const { t } = useTranslation();

  const [alarmsOpen, setAlarmsOpen] = useState(false);

  const { deviceId, virtualId } = useParams();
  const location = useLocation();

  // 🔹 Local bilgiler
  const role = localStorage.getItem("role");
  const deviceModel = localStorage.getItem("deviceModel");

  // 🔹 Sanal veya fiziksel cihaz ayrımı
  const saved = JSON.parse(localStorage.getItem("selectedDevice") || "{}");
  const isVirtual = saved.mode === "virtual";

  // 🔹 Fiziksel cihaz için type (boş kalmasın diye garantili)
  const rawDeviceType = localStorage.getItem("deviceType");
  const deviceType =
    rawDeviceType && rawDeviceType !== "null" ? rawDeviceType : "analyzer";

  // 🔹 Base path
  const basePath = isVirtual
    ? `/dashboard/${saved.virtualId || virtualId}`
    : role === "admin"
      ? `/admin/devices/${deviceId}`
      : `/devices/${deviceId}`;

  // 🔹 Menü listesi
  const menuItems = isVirtual
    ? [
      { label: "voltages", icon: Zap, path: "virtual/voltages" },
      { label: "currents", icon: Activity, path: "virtual/currents" },
      { label: "energies", icon: BatteryCharging, path: "virtual/energies", dropdown: false },
    ]
    : deviceType === "multimeter"
      ? [
        { label: "dashboard", icon: Radar, path: `${deviceType}/real-time` },
        { label: "voltages", icon: Zap, path: `${deviceType}/voltages` },
        { label: "currents", icon: Activity, path: `${deviceType}/currents` },
        { label: "apparentPower", icon: Eye, path: `${deviceType}/apparent-power` },
        {
          label: "demandValues",
          icon: SignalHigh,
          path: `${deviceType}/demand`,
        },
        {
          label: "alarms",
          icon: Bell,
          path: `${deviceType}/alarms`,
          dropdown: true,
          children: [
            { label: "relay1", path: `${deviceType}/alarms/relay1` },
            { label: "relay2", path: `${deviceType}/alarms/relay2` },
          ],
        },
      ]
      : deviceType === "voltampermetre"
        ? [
          { label: "dashboard", icon: Radar, path: `${deviceType}/real-time` },
          { label: "voltages",  icon: Zap,   path: `${deviceType}/voltages` },
          { label: "currents",  icon: Activity, path: `${deviceType}/currents` },
        ]
        : deviceType === "gruparge"
        ? [
          { label: "dashboard", icon: Radar, path: `${deviceType}/real-time` },
          { label: "voltages", icon: Zap, path: `${deviceType}/voltages` },
          { label: "currents", icon: Activity, path: `${deviceType}/currents` },
          { label: "cosfi", icon: TrendingUp, path: `${deviceType}/cosfi` },
          { label: "ratios", icon: Scale, path: `${deviceType}/ratios` },
          { label: "activePower", icon: Bolt, path: `${deviceType}/active-power` },
          { label: "inductivePower", icon: RotateCcw, path: `${deviceType}/inductive-power` },
          { label: "capacitivePower", icon: Eye, path: `${deviceType}/capacitive-power` },
          { label: "energies", icon: BatteryCharging, path: `${deviceType}/energies` },
        ]
        : [
          { label: "dashboard", icon: Radar, path: `${deviceType}/real-time` },
          { label: "voltages", icon: Zap, path: `${deviceType}/voltages` },
          { label: "currents", icon: Activity, path: `${deviceType}/currents` },
          { label: "cosfi", icon: TrendingUp, path: `${deviceType}/cosfi` },
          { label: "activePower", icon: Bolt, path: `${deviceType}/active-power` },
          { label: "reactivePower", icon: RotateCcw, path: `${deviceType}/reactive-power` },
          { label: "apparentPower", icon: Eye, path: `${deviceType}/apparent-power` },
          ...(deviceType !== "analyzer"
            ? [{ label: "ratios", icon: Scale, path: `${deviceType}/ratios` }]
            : []),
          { label: "powerFactors", icon: Gauge, path: `${deviceType}/power-factors` },
          ...(deviceType === "analyzer"
            ? [
              {
                label: "demandValues",
                icon: SignalHigh, // veya Activity / TrendingUp da olur
                path: `${deviceType}/demand`,
              },
            ]
            : []),
          ...(deviceType === "analyzer" && deviceModel !== "PAD-01"
            ? [{ label: "unbalances", icon: Divide, path: `${deviceType}/unbalances` }]
            : []),
          {
            label: "energies",
            icon: BatteryCharging,
            path: `${deviceType}/energies`,

          },
          ...(deviceModel === "PAD-02" || deviceModel === "PAD-03"
            ? [
              {
                label: "alarms",
                icon: Bell,
                path: `${deviceType}/alarms`,
                dropdown: true,
                children: [
                  { label: "relay1", path: `${deviceType}/alarms/relay1` },
                  { label: "relay2", path: `${deviceType}/alarms/relay2` },
                ],
              },
            ]
            : []),

          ...((deviceType === "reactive" || deviceType === "analyzer")
            ? [
              {
                label: "harmonics",
                icon: SignalHigh,
                path: `${deviceType}/harmonics`,
              },
              ...(deviceType === "reactive"
                ? [
              {
                label: "steps",
                icon: Layers3,
                path: `${deviceType}/steps`,
              },
              {
                label: "settings",
                icon: Settings,
                path: `${deviceType}/settings`,
              },
                ]
                : []),
            ]
            : []
          )
        ];




  return (
    <>
      {/* Mobile backdrop */}
      {isOpen && (
        <div
          onClick={onClose}
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-screen w-64 bg-gray-900 text-white p-4 z-50 overflow-y-auto scrollbar-hide
        transform transition-transform duration-300
        ${isOpen ? "translate-x-0" : "-translate-x-full"}
        lg:translate-x-0`}
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold">
            {isVirtual ? t('sidebar.virtualDevicePanel') : t('sidebar.devicePanel')}
          </h2>
          <button onClick={onClose} className="lg:hidden text-gray-400 hover:text-white">
            <X size={24} />
          </button>
        </div>

        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.label}>
              {/* Dropdown (Enerjiler / Alarmlar) */}
              {item.dropdown ? (
                <button
                  onClick={() => {

                    if (item.label === "alarms") setAlarmsOpen(!alarmsOpen);
                  }}
                  className={`flex w-full items-center justify-between gap-3 px-4 py-2 rounded-lg transition ${item.label === "alarms" && alarmsOpen
                    ? "bg-gray-700 text-white"
                    : "text-gray-300 hover:bg-gray-800 hover:text-white"
                    }`}

                >
                  <div className="flex items-center gap-3">
                    <item.icon className="w-5 h-5" />
                    <span>{t(`sidebar.${item.label}`)}</span>
                  </div>
                  {
                    (item.label === "alarms" && alarmsOpen) ? (
                      <ChevronLeft className="w-4 h-4" />
                    ) : (
                      <ChevronDown className="w-4 h-4" />
                    )}
                </button>
              ) : (
                // Normal menü
                <NavLink
                  to={`${basePath}/${item.path}`}
                  onClick={onClose}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-2 rounded-lg transition ${isActive
                      ? "bg-indigo-600 text-white"
                      : "text-gray-300 hover:bg-gray-800 hover:text-white"
                    }`
                  }
                >
                  <item.icon className="w-5 h-5" />
                  <span>{t(`sidebar.${item.label}`)}</span>
                </NavLink>
              )}



              {/* Alarmlar alt menüsü */}
              {item.label === "alarms" && alarmsOpen && (
                <ul className="ml-8 mt-2 space-y-1">
                  {item.children?.map((sub) => (
                    <li key={sub.label}>
                      <NavLink
                        to={`${basePath}/${sub.path}`}
                        className={({ isActive }) =>
                          `block px-3 py-1 rounded-md text-sm transition ${isActive
                            ? "bg-indigo-600 text-white"
                            : "text-gray-400 hover:bg-gray-700 hover:text-white"
                          }`
                        }
                      >
                        {t(`sidebar.${sub.label}`)}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>

        {/* --- Alt Butonlar --- */}
        <div className="mt-6 pt-4 border-t border-gray-700 space-y-3">

          {/* Ana sayfaya dön */}
          <NavLink
            to="/"
            onClick={onClose}
            className="flex items-center gap-3 px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 transition"
          >
            <Home className="w-5 h-5" />
            <span>{t('sidebar.homePage')}</span>
          </NavLink>

          {/* Cihaz Listesine Dön */}
          <button
            onClick={() => {
              const gwId = localStorage.getItem("gatewayId");
              if (gwId) {
                onClose();
                window.location.href = `/gateways/${gwId}/devices`;
              }
            }}
            className="flex items-center gap-3 w-full px-4 py-2 rounded-lg bg-gray-700 hover:bg-gray-600 transition"
          >
            <ChevronLeft className="w-5 h-5" />
            <span>{t('sidebar.deviceList')}</span>
          </button>

        </div>

      </div>
    </>
  );
}
